import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";


declare var ko: any;

export class txnInitSplitView_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `
        
                <div class="form-header">
                    <input type="hidden">
                    
                    <button data-bind="event: { click: onClickCancel }" class="btn secondary only-icon icon i-back" type="button"></button>

                    <h3 class="form-title icon i-transaction">Transaction Initiative Split</h3>

                    <button data-bind="event: { click: onClickEdit }" class="btn secondary only-icon icon i-edit" type="button"></button>
                </div>
                
                <div id="view-results" class="form-body padding-bottom"> 
                  
                    <div class="form-group" data-bind="using: brand" style="margin-bottom: 1rem;">
                       <span class="form-label" data-bind="text: name, css: iconImage"></span>
                    </div> 
                    <div class="form-group" >
                        <hr />
                    </div> 
                    <div class="form-group" style="margin-bottom: 1rem;">
                        <span class="form-label icon i-user" data-bind="text: userName"></span>
                    </div> 
                    <div class="form-group" >
                        <hr />
                    </div>
                    <div class="form-group view">
                        <legend class="form-legend">Initiatives</legend>
                        
                        <div data-bind="foreach: initiativeSplits">
                            
                            <!-- ko if:disabled == true -->
                            <div class="row">
                                <input type="checkbox" onclick="return false;" class="read-only" value="1" id="1">
                                <label class="form-label icon i-check" for="1" data-bind="text: name"></label>
                                <input class="input-text num read-only" readonly type="text" value="0" />
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if:disabled == false -->
                            <div class="row">
                                <input type="checkbox" onclick="return false;" class="read-only" checked value="1" id="1">
                                <label class="form-label icon i-check" for="1" data-bind="text: name"></label>
                                <input class="input-text num read-only" readonly type="text" data-bind="value: split + '%'" />
                            </div>
                            <!-- /ko -->
                        </div>
                    </div> 
                </div>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string {
        return "txnInitSplitView_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "margin-top", "transaction-int"];
    }

    protected buildViewModel(): any {

        let myself = this;
        return {
            brand: ko.observable({'name': '', 'iconImage':''}),
            userName: ko.observable(""),
            initiatives: ko.observableArray([]),
            initiativeSplits: ko.observableArray([]),
            initiativeSelectorVisible: ko.observable(0),
            onClickCancel: function (data, event) {
                myself.onClickCancel();
            },
            onClickEdit: function (data, event) {
                myself.onClickEdit();
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {

        }
    }


    //
    // click on cancel button
    protected onClickCancel(): void {
        this.caller.cancelViewTxnInitSplit();
    }

    //
    // click on cancel button
    protected onClickEdit(): void {
        this.caller.editTxnInitSplit();
    }

    public setInitiatives(items){

        for (let item of items){
            item['name'] = item['initiative'];
        }
        //this.initiativesSelector.setItems(items);
        this.getTemplateViewModel().initiatives(items);
    }

    public setBrand(brand) {

        this.getTemplateViewModel().brand(brand);
    }

    public setUser(user) {

        this.getTemplateViewModel().userName(user.fullName);
    }

    public setInitiativeSplits(sourceInitiativeSplits) {

        let initiatives = this.getTemplateViewModel().initiatives();
        let initiativeSplits = [];
        let initiativeSplitIds = [];
        for(let initiative of initiatives) {

            let tmp = [];
            tmp['name'] = initiative.name;
            tmp['disabled'] = true;
            tmp['split'] = 0;

            let split = sourceInitiativeSplits.find(i => i.idInitiative === initiative.id);
            if (split) {

                tmp['disabled'] = false;
                tmp['split'] = split.split;
            }

            initiativeSplits.push(tmp);

        }

        this.getTemplateViewModel().initiativeSplits(initiativeSplits);
    }

    //
    // error
    protected onUpdateError(status, data): void {
        console.log('onUpdateError' + status);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/txnInitSplitView_template.ts